import { createFileRoute } from '@tanstack/react-router'
import { EmplacementForm } from '@features/stock/components/EmplacementForm'
import { useQuery } from '@tanstack/react-query'
import api from '@lib/utils/api'
import { queryKeys } from '@lib/api/queryKeys'
import { usePermissions } from '@lib/hooks/usePermissions'
import { requirePermission } from '@lib/permissions/guards'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'

export const Route = createFileRoute('/_app/stock/emplacements/$id/edit')({
  beforeLoad: ({ context }) => {
    requirePermission(PERMISSIONS.STOCK.EMPLACEMENTS.EDIT, context)
  },
  component: EditEmplacementComponent,
})

function EditEmplacementComponent() {
  const { id } = Route.useParams()
  const { canEdit } = usePermissions()
    
  const { data } = useQuery({
    queryKey: queryKeys.stock.emplacements.details(Number(id)),
    queryFn: async () => {
      const response = await api.get(`/emplacements/${id}`)
      return response.data
    },
  })

  if (!canEdit('stock.emplacements.edit')) {
    return <div className="p-6">Accès non autorisé</div>
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Modifier Emplacement</h1>
      {data && <EmplacementForm mode="edit" initialData={data} />}
    </div>
  )
}
